var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"top"},[_vm._v("便捷 | 智能")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("在线考试系统")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('a',{staticClass:"btn-blue-hover",staticStyle:{"margin-right":"20px"},on:{"click":_vm.goTest}},[_vm._v("现在体验")]),_c('a',{staticClass:"btn-fff",on:{"click":_vm.chatShow}},[_vm._v("咨询顾问")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('span',[_vm._v("8")]),_vm._v(" 大场景，"),_c('span',[_vm._v("10")]),_vm._v(" 大题型，"),_c('span',[_vm._v("12")]),_vm._v("\n    种防作弊措施"),_c('br'),_vm._v("\n    微信扫一扫，现在就能考！\n  ")])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/product/exam/banner.vue?vue&type=template&id=88bc5f82&scoped=true
// module id = null
// module chunks = 